import Layout from '@/components/feature/Layout';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const canonicalUrl = 'https://91.cc';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '91.cc 官方平台入口与核心功能全解析',
    url: canonicalUrl,
    description: '91.cc 是备受用户关注的网络平台，本页详细介绍 91.cc 的官方入口、核心功能、使用指南及常见问题解答，帮助用户快速了解 91.cc 的全部服务与最新动态。',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${canonicalUrl}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <Layout>
      <SEO
        title="91.cc – 官方平台入口与核心功能全解析"
        description="91.cc 是备受用户关注的网络平台，本页详细介绍 91.cc 的官方入口、核心功能、使用指南及常见问题解答，帮助用户快速了解 91.cc 的全部服务与最新动态，安全、便捷地访问 91.cc。"
        keywords="91.cc,91.cc官方入口,91.cc使用指南,91.cc最新地址,91.cc功能介绍,91.cc常见问题,91.cc安全访问"
        canonicalUrl={canonicalUrl}
        jsonLd={jsonLd}
      />
      <HeroSection />
      <FeaturesSection />
      <LatestArticles />
      <FAQSection />
      <CTASection />
    </Layout>
  );
}